export default __webpack_public_path__ + "static/media/ic_yellow_circle.566ae2b3.svg";